module.exports = function getResource(label, vars = []) {
    const resources = {
        modalTitleRegister: 'S’inscrire auprès de sephora',
        modalTitleCreate: 'Create An Account',
        modalTitleComplete: 'Terminer la configuration du compte'
    };

    return resources[label];
};
